// Admin types the backend accepts, with the admin_section_id it derives from
// each (services/authentication/models/adminUser.js pre-save hook).
export const ADMIN_TYPES = [
  { value: "SUPER", label: "Super Admin", sectionId: 1 },
  { value: "UTILITY", label: "Utility Admin", sectionId: 2 },
  { value: "FINANCE", label: "Finance Admin", sectionId: 3 },
  { value: "FLIGHT", label: "Flight Admin", sectionId: 5 },
  { value: "INSURANCE", label: "Insurance Admin", sectionId: 7 },
  { value: "MARKETING", label: "Marketing Admin", sectionId: 6 },
  { value: "ENGINEER-1", label: "Level 1 Engineer", sectionId: 4 },
  { value: "ENGINEER-2", label: "Level 2 Engineer", sectionId: 4 },
  { value: "ENGINEER-3", label: "Level 3 Engineer", sectionId: 4 },
];

export const SECTION_TAGS = {
  1: { color: "red", label: "SUPER ADMIN" },
  2: { color: "blue", label: "UTILITY ADMIN" },
  3: { color: "green", label: "FINANCE ADMIN" },
  4: { color: "blue", label: "ENGINEER" },
  5: { color: "orange", label: "FLIGHT ADMIN" },
  6: { color: "green", label: "MARKETING ADMIN" },
  7: { color: "purple", label: "INSURANCE ADMIN" },
};

export const adminTypeLabel = (value) =>
  ADMIN_TYPES.find((type) => type.value === value)?.label || value;
